var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "ma-0 pa-0", attrs: { fluid: "" } },
    [
      _c(
        "div",
        { staticClass: "d-flex align-stretch" },
        [
          _c(
            "div",
            { staticClass: "flex-grow-1", staticStyle: { "min-width": "0" } },
            [
              _c("v-data-table", {
                attrs: {
                  headers: _vm.displayHeaders,
                  height: _vm.tableSize,
                  items: _vm.filteredItems,
                  "items-per-page": _vm.pageSize,
                  loading: _vm.loading,
                  search: _vm.search,
                  "sort-by": _vm.sortBy,
                  "sort-desc": _vm.sortDesc,
                  dense: "",
                  "fixed-header": "",
                  "item-key": "ad_plan_id",
                  "loading-text": "Loading... Please Wait",
                  "no-results-text": "No matching items found",
                  "no-data-text": _vm.selectedAdGroup
                    ? "No current or future ad planner items found"
                    : "Select an ad group to view ad planner items",
                },
                on: {
                  "update:sortBy": function ($event) {
                    _vm.sortBy = $event
                  },
                  "update:sort-by": function ($event) {
                    _vm.sortBy = $event
                  },
                  "update:sortDesc": function ($event) {
                    _vm.sortDesc = $event
                  },
                  "update:sort-desc": function ($event) {
                    _vm.sortDesc = $event
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "top",
                      fn: function () {
                        return [
                          _c(
                            "v-toolbar",
                            {
                              staticClass: "py-2",
                              staticStyle: { cursor: "default" },
                              attrs: {
                                flat: "",
                                color: "toolbar",
                                height: "auto",
                              },
                            },
                            [
                              _c(
                                "v-row",
                                { attrs: { dense: "", align: "center" } },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass:
                                        "d-flex flex-wrap align-center",
                                      attrs: { cols: "12" },
                                    },
                                    [
                                      _c("v-toolbar-title", [
                                        _vm._v("Ad Planner Search"),
                                      ]),
                                      _c("v-divider", {
                                        staticClass: "mx-4",
                                        attrs: { vertical: "", inset: "" },
                                      }),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "text-caption grey--text",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.items.length.toLocaleString()
                                              ) +
                                              " items across " +
                                              _vm._s(_vm.plannerCount) +
                                              " current/future planners "
                                          ),
                                        ]
                                      ),
                                      _vm.loadWarning
                                        ? _c(
                                            "v-chip",
                                            {
                                              staticClass: "ml-3",
                                              attrs: {
                                                small: "",
                                                color: "amber",
                                                "text-color": "white",
                                              },
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    left: "",
                                                    small: "",
                                                  },
                                                },
                                                [_vm._v("mdi-alert-outline")]
                                              ),
                                              _vm._v(
                                                _vm._s(_vm.loadWarning) + " "
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _c("v-spacer"),
                                      _c(
                                        "v-menu",
                                        {
                                          attrs: {
                                            "offset-y": "",
                                            "close-on-content-click": false,
                                            "max-width": "320",
                                          },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "activator",
                                              fn: function ({
                                                on: menuOn,
                                                attrs,
                                              }) {
                                                return [
                                                  _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: { top: "" },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function ({
                                                              on: tipOn,
                                                            }) {
                                                              return [
                                                                _c(
                                                                  "v-btn",
                                                                  _vm._g(
                                                                    _vm._b(
                                                                      {
                                                                        staticClass:
                                                                          "grey lighten-2 mr-2",
                                                                      },
                                                                      "v-btn",
                                                                      attrs,
                                                                      false
                                                                    ),
                                                                    {
                                                                      ...menuOn,
                                                                      ...tipOn,
                                                                    }
                                                                  ),
                                                                  [
                                                                    _c(
                                                                      "v-icon",
                                                                      [
                                                                        _vm._v(
                                                                          "mdi-content-save-cog-outline"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v("Saved Views"),
                                                      ]),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ]),
                                        },
                                        [
                                          _c(
                                            "v-list",
                                            { attrs: { dense: "" } },
                                            [
                                              _c("v-subheader", [
                                                _vm._v("Saved Views"),
                                              ]),
                                              !_vm.savedViews.length
                                                ? _c(
                                                    "v-list-item",
                                                    { attrs: { disabled: "" } },
                                                    [
                                                      _c(
                                                        "v-list-item-content",
                                                        [
                                                          _c(
                                                            "v-list-item-title",
                                                            {
                                                              staticClass:
                                                                "grey--text",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "No saved views yet"
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._l(
                                                _vm.savedViews,
                                                function (view) {
                                                  return _c(
                                                    "v-list-item",
                                                    {
                                                      key: view.id,
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.applyView(
                                                            view
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-list-item-content",
                                                        [
                                                          _c(
                                                            "v-list-item-title",
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  view.name
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-list-item-action",
                                                        [
                                                          _c(
                                                            "v-btn",
                                                            {
                                                              attrs: {
                                                                icon: "",
                                                                small: "",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                    return _vm.deleteView(
                                                                      view.id
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-icon",
                                                                {
                                                                  attrs: {
                                                                    small: "",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "mdi-delete-outline"
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                              _c("v-divider"),
                                              _c(
                                                "v-list-item",
                                                {
                                                  on: {
                                                    click:
                                                      _vm.openSaveViewDialog,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-list-item-icon",
                                                    { staticClass: "mr-2" },
                                                    [
                                                      _c("v-icon", [
                                                        _vm._v("mdi-plus"),
                                                      ]),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-list-item-content",
                                                    [
                                                      _c("v-list-item-title", [
                                                        _vm._v(
                                                          "Save current view…"
                                                        ),
                                                      ]),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            2
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-tooltip",
                                        {
                                          attrs: { top: "" },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "activator",
                                              fn: function ({ on }) {
                                                return [
                                                  _c(
                                                    "v-btn",
                                                    _vm._g(
                                                      {
                                                        staticClass:
                                                          "grey lighten-2 mr-2",
                                                        on: {
                                                          click:
                                                            _vm.openColumnsModal,
                                                        },
                                                      },
                                                      on
                                                    ),
                                                    [
                                                      _c("v-icon", [
                                                        _vm._v(
                                                          "mdi-table-edit"
                                                        ),
                                                      ]),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ]),
                                        },
                                        [
                                          _c("span", [
                                            _vm._v("Ordering Headers"),
                                          ]),
                                        ]
                                      ),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            outlined: "",
                                            disabled: !_vm.filteredItems.length,
                                          },
                                          on: { click: _vm.exportCsv },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { left: "" } },
                                            [_vm._v("mdi-download")]
                                          ),
                                          _vm._v("CSV "),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { md: "3", lg: "2" } },
                                    [
                                      _c("v-autocomplete", {
                                        attrs: {
                                          "auto-select-first": "",
                                          items: _vm.userAdGroups,
                                          "item-text": "name",
                                          "item-value": "id",
                                          "return-object": "",
                                          "hide-no-data": "",
                                          "background-color": "input",
                                          label: "Ad Group",
                                          outlined: "",
                                          dense: "",
                                          "hide-details": "",
                                          "prepend-inner-icon":
                                            "mdi-filter-outline",
                                          "menu-props": { maxHeight: 260 },
                                        },
                                        model: {
                                          value: _vm.selectedAdGroup,
                                          callback: function ($$v) {
                                            _vm.selectedAdGroup = $$v
                                          },
                                          expression: "selectedAdGroup",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { md: "4", lg: "3" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          "background-color": "input",
                                          label: "Search",
                                          placeholder: "Search all columns...",
                                          outlined: "",
                                          dense: "",
                                          "hide-details": "",
                                          clearable: "",
                                          "prepend-inner-icon": "mdi-magnify",
                                        },
                                        model: {
                                          value: _vm.search,
                                          callback: function ($$v) {
                                            _vm.search = $$v
                                          },
                                          expression: "search",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { md: "3", lg: "2" } },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "justify-start",
                                          staticStyle: { height: "40px" },
                                          attrs: {
                                            outlined: "",
                                            block: "",
                                            color: "primary",
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.filterDrawer = true
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { left: "" } },
                                            [_vm._v("mdi-filter-variant")]
                                          ),
                                          _vm._v(" Filters "),
                                          _vm.activeFilterCount
                                            ? _c(
                                                "v-chip",
                                                {
                                                  staticClass:
                                                    "ml-2 white--text",
                                                  attrs: {
                                                    "x-small": "",
                                                    color: "primary",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.activeFilterCount
                                                    )
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _c("v-spacer"),
                                          _c(
                                            "v-icon",
                                            { attrs: { right: "" } },
                                            [_vm._v("mdi-chevron-left")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: `item.ad_start_date`,
                      fn: function ({ item }) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.formatDateDisplay(item.ad_start_date)
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                    {
                      key: `item.ad_end_date`,
                      fn: function ({ item }) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(_vm.formatDateDisplay(item.ad_end_date)) +
                              " "
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              }),
            ],
            1
          ),
          _c("v-expand-x-transition", [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.filterDrawer,
                    expression: "filterDrawer",
                  },
                ],
                staticClass: "flex-shrink-0",
                staticStyle: {
                  width: "340px",
                  "border-left": "1px solid rgba(0,0,0,0.12)",
                },
              },
              [
                _c("AdPlannerSearchFilters", {
                  attrs: {
                    "position-options": _vm.positionOptions,
                    "department-options": _vm.departmentOptions,
                    "promo-category-options": _vm.promoCategoryOptions,
                    "vendor-options": _vm.vendorOptions,
                    "category-options": _vm.categoryOptions,
                    "subcategory-options": _vm.subcategoryOptions,
                    "epay-compete-options": _vm.epayCompeteOptions,
                  },
                  on: {
                    close: function ($event) {
                      _vm.filterDrawer = false
                    },
                  },
                  model: {
                    value: _vm.filters,
                    callback: function ($$v) {
                      _vm.filters = $$v
                    },
                    expression: "filters",
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "600px", scrollable: "", persistent: "" },
          model: {
            value: _vm.showColumnsModal,
            callback: function ($$v) {
              _vm.showColumnsModal = $$v
            },
            expression: "showColumnsModal",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "accent white--text pa-3 justify-center" },
                [_vm._v("Ordering Headers")]
              ),
              _c(
                "v-card-text",
                { staticClass: "pt-4" },
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "6" } },
                        [
                          _c("h3", { staticClass: "text-center mb-2" }, [
                            _vm._v("Display Order"),
                          ]),
                          _c(
                            "draggable",
                            {
                              staticClass: "list-group",
                              attrs: {
                                list: _vm.displayHeadersDraft,
                                group: "headers",
                              },
                              on: { end: _vm.onDragEnd },
                            },
                            _vm._l(_vm.displayHeadersDraft, function (header) {
                              return _c(
                                "div",
                                {
                                  key: header.value,
                                  staticClass: "list-group-item pa-2 my-1",
                                },
                                [_vm._v(" " + _vm._s(header.text) + " ")]
                              )
                            }),
                            0
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "6" } },
                        [
                          _c("h3", { staticClass: "text-center mb-2" }, [
                            _vm._v("Hide"),
                          ]),
                          _c(
                            "draggable",
                            {
                              staticClass: "list-group",
                              attrs: {
                                list: _vm.hideHeadersDraft,
                                group: "headers",
                              },
                              on: { end: _vm.onDragEnd },
                            },
                            _vm._l(_vm.hideHeadersDraft, function (header) {
                              return _c(
                                "div",
                                {
                                  key: header.value,
                                  staticClass: "list-group-item pa-2 my-1",
                                },
                                [_vm._v(" " + _vm._s(header.text) + " ")]
                              )
                            }),
                            0
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "grey lighten-4" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "accent white--text" },
                      on: { click: _vm.resetHeaders },
                    },
                    [_vm._v("Reset")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "green darken-1 white--text" },
                      on: { click: _vm.saveHeadersOrder },
                    },
                    [_vm._v("Save")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "420px", persistent: "" },
          model: {
            value: _vm.showSaveViewDialog,
            callback: function ($$v) {
              _vm.showSaveViewDialog = $$v
            },
            expression: "showSaveViewDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "accent white--text pa-3" }, [
                _vm._v("Save Current View"),
              ]),
              _c(
                "v-card-text",
                { staticClass: "pt-4" },
                [
                  _c("v-text-field", {
                    attrs: {
                      label: "View name",
                      outlined: "",
                      dense: "",
                      autofocus: "",
                      "hide-details": "",
                    },
                    on: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.saveCurrentView.apply(null, arguments)
                      },
                    },
                    model: {
                      value: _vm.newViewName,
                      callback: function ($$v) {
                        _vm.newViewName = $$v
                      },
                      expression: "newViewName",
                    },
                  }),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "grey lighten-4" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "" },
                      on: {
                        click: function ($event) {
                          _vm.showSaveViewDialog = false
                        },
                      },
                    },
                    [_vm._v("Cancel")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "green darken-1 white--text",
                        disabled: !_vm.newViewName.trim(),
                      },
                      on: { click: _vm.saveCurrentView },
                    },
                    [_vm._v("Save")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }